import React from "react";

const Change: React.FC<React.SVGProps<SVGSVGElement>> = ({
	width = 24,
	height = 24,
	...props
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			aria-label="Change icon"
			{...props}
		>
			<path
				d="M4 11.75C4.41421 11.75 4.75 12.0858 4.75 12.5V14C4.75002 15.7949 6.20509 17.25 8 17.25H16.1895L14.9697 16.0303C14.6768 15.7374 14.6769 15.2626 14.9697 14.9697C15.2626 14.6768 15.7374 14.6768 16.0303 14.9697L18.5303 17.4697C18.8232 17.7626 18.8232 18.2374 18.5303 18.5303L16.0303 21.0303C15.7374 21.3232 15.2626 21.3232 14.9697 21.0303C14.6768 20.7374 14.6768 20.2626 14.9697 19.9697L16.1895 18.75H8C5.37666 18.75 3.25002 16.6233 3.25 14V12.5C3.25 12.0858 3.58579 11.75 4 11.75ZM7.96973 2.96973C8.26262 2.67684 8.73738 2.67684 9.03027 2.96973C9.32316 3.26262 9.32317 3.73738 9.03027 4.03027L7.81055 5.25H16C18.6234 5.25 20.75 7.37665 20.75 10V11.5C20.75 11.9142 20.4142 12.25 20 12.25C19.5858 12.25 19.25 11.9142 19.25 11.5V10C19.25 8.20508 17.7949 6.75 16 6.75H7.81055L9.03027 7.96973C9.32317 8.26262 9.32316 8.73738 9.03027 9.03027C8.73738 9.32317 8.26262 9.32317 7.96973 9.03027L5.46973 6.53027C5.32907 6.38962 5.25 6.19891 5.25 6C5.25 5.80109 5.32907 5.61038 5.46973 5.46973L7.96973 2.96973Z"
				fill="#23262A"
			/>
		</svg>
	);
};

export default Change;